export const WILDCARD = '*';
